import { v4 as uuidv4 } from 'uuid';

const animation = [
    {
        idSoft: uuidv4(),
        name: 'NONE',
        text: 'Aucune',
        value: 0,
        action: (classReturn) => {
            classReturn["animation-none"] = true;
            return classReturn;
        }
    },
    {
        idSoft: uuidv4(),
        name: 'WOW_TOP',
        text: 'Arrivée par le haut',
        value: 1,
        action: (classReturn) => {
            classReturn["animation-wow-top"] = true;
            return classReturn;
        }
    },
    {
        idSoft: uuidv4(),
        name: 'WOW_BOTTOM',
        text: 'Arrivée par le bas',
        value: 2,
        action: (classReturn) => {
            classReturn["animation-wow-bottom"] = true;
            return classReturn;
        }
    },
    {
        idSoft: uuidv4(),
        name: 'WOW_LEFT',
        text: 'Arrivée par la gauche',
        value: 3,
        action: (classReturn) => {
            classReturn["animation-wow-left"] = true;
            return classReturn;
        }
    },
    {
        idSoft: uuidv4(),
        name: 'WOW_RIGHT',
        text: 'Arrivée par la droite',
        value: 4,
        action: (classReturn) => {
            classReturn["animation-wow-right"] = true;
            return classReturn;
        }
    },
    {
        idSoft: uuidv4(),
        name: 'OPACITY',
        text: 'Opacité',
        value: 5,
        action: (classReturn) => {
            classReturn["animation-opacity"] = true;
            return classReturn;
        }
    },
    {
        idSoft: uuidv4(),
        name: 'ZOOM_IN',
        text: 'Agrandissement',
        value: 6,
        action: (classReturn) => {
            classReturn["animation-zoom-in"] = true;
            return classReturn;
        }
    },
    {
        idSoft: uuidv4(),
        name: 'ZOOM_OUT',
        text: 'Réduction',
        value: 7,
        action: (classReturn) => {
            classReturn["animation-zoom-out"] = true;
            return classReturn;
        }
    },
];
export default animation;
